import Vue from 'vue'
import Router from 'vue-router'
import home from '@/page/home'
import etarget from '@/page/etarget'
// import lasershooting from '@/page/lasershooting'
import erange from '@/page/erange'
import service from '@/page/service'
import about from '@/page/about'
import supershooter from '@/page/childrens/supershooter'
import live from '@/page/childrens/live'
import bigdata from '@/page/childrens/bigdata'
import competitionservice from '@/page/childrens/competitionservice'
import aftersaleservice from '@/page/childrens/aftersaleservice'
import intro from '@/page/childrens/intro'
import honor from '@/page/childrens/honor'
import customer from '@/page/childrens/customer'
import recruit from '@/page/childrens/recruit'
import contact from '@/page/childrens/contact'
import article from '@/page/article'
import articlelist from '@/page/articlelist'
import video from '@/page/video'
import videolist from '@/page/videolist'





Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
    },
    {
      path: '/etarget',
      name: 'etarget',
      component: etarget,
    },
    // {
    //   path: '/lasershooting',
    //   name: 'lasershooting',
    //   component: lasershooting,
    // },
    {
      path: '/erange',
      name: 'erange',
      component:erange,
    },
    {
      path: '/service',
      name: 'service',
      component:service,
      children:[
        { path: 'supershooter',name:'supershooter', component: supershooter},
        { path: 'live',name:'live', component: live},
        { path: 'bigdata',name:'bigdata', component: bigdata},
        { path: 'competitionservice',name:'competitionservice', component: competitionservice},
        { path: 'aftersaleservice',name:'aftersaleservice', component: aftersaleservice},
      ]
    },
    {
      path: '/about',
      name: 'about',
      component:about,
      children:[
        { path: 'intro',name:'intro', component: intro},
        { path: 'honor',name:'honor', component: honor},
        { path: 'customer',name:'customer', component: customer},
        { path: 'recruit',name:'recruit', component: recruit},
        { path: 'contact',name:'contact', component: contact},
      ]
    },
    {
      path: '/article/:id',
      name: 'article',
      component:article,
    },
    {
      path: '/articlelist',
      name: 'articlelist',
      component:articlelist,
    },
    {
      path: '/video/:id',
      name: 'video',
      component:video,
    },
    {
      path: '/videolist',
      name: 'videolist',
      component:videolist,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js